<template lang="pug">
  .filter-sheet
    y-bottom-sheet(v-model="showSheet" inset scrollable max-width="600px")
      v-card(flat)
        v-card-title.px-4
          div.h6.basic800--text {{ $t('filter_chart') }}
          v-spacer
          v-btn(color="white" text @click="clearFilters")
            .button-Aa-small.primary400--text {{ $t('clear_filters') }}
          v-btn(color="textColorAccent" depressed height=32 dark @click="filterData")
            .button-AA-small.basic100--text {{ $t('filter') }}
        v-divider.basic300
        v-card-text.px-4.pb-8
          .date.mt-4
            div.d-flex
              p.mb-1.label.basic600--text.text-uppercase {{ $t('date') }}
              v-spacer
              p.mb-1.c1.basic600--text(v-if="range.id === 'custom' && selectedDateRange.length > 0") 
                template(v-if="selectedDateRange.length > 1") {{ selectedDateRange[0] | humanizeDate }} ~ {{ selectedDateRange[1] | humanizeDate }}
                template(v-else) {{ selectedDateRange[0] | humanizeDate }}
            v-select.mt-2(item-color="basic100" v-model="range" :items="dateRangeSelections" item-text="text" item-value="value" background-color="basic200" height="40" outlined dense hide-details append-icon="mdi-chevron-down")
              template(v-slot:item="{ item }")
                v-list-item-content(v-if="item.value.id === 'custom'" @click="customDateRangePickerDialog = true")
                  v-list-item-title {{ item.text }}
                v-list-item-content(v-else)
                  v-list-item-title {{ item.text }}
                  //- v-list-item-action(v-if="item.value === 'custom'")
                    v-btn.mr-2.black--text(color="black" depressed outlined x-small @click.stop="clickShowFormExample(item.value)") Example

    .modals
      date-range-picker-dialog(:dialog.sync="customDateRangePickerDialog" @selected="dateRangeSelected($event)")
      form-filter-dialog(v-if="openFormFilterDialog" :open.sync="openFormFilterDialog" :company="company" @selected="handleSelectedForm")

</template>

<script>
import DateRangePickerDialog from '@/views/admin/database/DateRangePickerDialog.vue'
import FormFilterDialog from '@/views/admin/database/FormFilterDialog.vue'

export default {
  name: 'FilterChartSheet',
  components: { DateRangePickerDialog, FormFilterDialog },
  props: ['open', 'company', 'filtered'],
  data: () => ({
    source: { name: 'All', id: '' },
    range: { name: 'This week', id: 'week' },
    selectedDateRange: [],
    dateRangeSelections: [
      { text: 'Today', value: { name: 'Today', id: 'day' } },
      { text: 'This week', value: { name: 'This week', id: 'week' } },
      { text: 'This month', value: { name: 'This month', id: 'month' } },
      { text: 'This year', value: { name: 'This year', id: 'year' } },
      { text: 'Custom range', value: { name: 'Custom range', id: 'custom' } }
    ],
    openFormFilterDialog: false,
    customDateRangePickerDialog: false,
  }),
  computed: {
    showSheet: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  watch: {

  },
  mounted () {
    if (this.filtered.source) {
      this.source = this.filtered.source
    }
    if (this.filtered.range) {
      this.range = this.filtered.range
    }
    if (this.filtered.selectedDateRange) {
      this.selectedDateRange = this.filtered.selectedDateRange
    }
  },
  methods: {
    filterData () {
      let data = {}
      if (this.source.id) {
        data.source = this.source
      }
      if (this.range.id) {
        data.range = this.range
        data.selectedDateRange = this.selectedDateRange
      }
      this.$emit('filtered', data)
      this.showSheet = false
    },
    clearFilters () {
      this.source = { name: 'All', id: '' }
      this.range = { name: 'This week', id: 'week' }
      this.selectedDateRange = []
      this.filterData()
    },
    handleSelectedForm (form) {
      this.source = {
        name: form.name, id: form.id
      }
    },
    dateRangeSelected (dates) {
      this.selectedDateRange = dates
      this.range = { name: 'Custom range' , id: 'custom' }
    },
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
div >>> .v-list-item--active{
  background-color: var(--v-info500) !important;
  color:white;
}
</style>
